export default __webpack_public_path__ + "static/char-s-48-ja-b00b20bce5356db4b30a90241325d9a3.png";